module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAjCAYAAACU9ioYAAAABHNCSVQICAgIfAhkiAAAALhJREFUSEut1lsOxSAIBFBmp3Vltzv1JiY2fSgwgN/mxEFCgCRP7/0QkZ+INAAnMt4Nm0wLgwtsoCFwh43YbGQVY2toYVRkD+YGvZgLZDATZDEVjGBbMIotwQz2AbPYA6zALrAKG2AlNsG+GhAA6MFhvfAE0NhpNF6hxKbRK1YV+qhTBfopfBZd/mQG3bZGFFV7LYKazcuiJsj2qQtkUDfoRSnQg9KgibLTZN4v3b4UlN++3oneG+wf44GpzzC4N4MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.png
// module id = DtD7
// module chunks = 75